import { render } from "./Container.vue?vue&type=template&id=b789e47a&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"

import "./Container.vue?vue&type=style&index=0&id=b789e47a&lang=scss&scoped=true"
import "./Container.vue?vue&type=style&index=1&id=b789e47a&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b789e47a"]])

export default __exports__